import React from 'react';

import Icon from './Icon';

const Linegraphic = () => {
  return (
    <div className="relative">
      <img
        src="/linegraphic.svg"
        className="hidden md:block max-w-full mx-auto"
        alt="The Content API for Market Leading Applications"
      />
      <img
        src="/linegraphic-mobile.svg"
        className="md:hidden max-w-full mx-auto"
        alt="The Content API for Market Leading Applications"
      />
      <div className="hidden md:flex absolute inset-1/2 items-center justify-center">
        <div className="absolute bg-white flex items-center justify-center rounded-full text-haiti w-24 h-24 md:h-40 md:w-40 z-40">
          <Icon size="large" />
        </div>
        {new Array(3).fill(0).map((_, index) => {
          const delayVal = index + 1;

          return (
            <div
              className={`absolute animation-delay-${delayVal}s animation-4s animation-fill-both animation-infinite animation-ripple animation-gradual h-48 md:h-96 rounded-full w-24 md:w-96`}
              style={{ border: '150px solid #fff' }}
              key={index}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

export default Linegraphic;
